<!-- #################################################################################### -->
<!-- ###### HERINCOHAN                                                             ###### -->
<!-- ###### @author: Diego Alexander Villalba Cely                                 ###### -->
<!-- ###### @date: Septiembre 2025                                                 ###### -->
<!-- #################################################################################### -->

<!-- #################################################################################### -->
<!-- ###### Sección de HTML                                                        ###### -->
<!-- #################################################################################### -->
<template>
  <v-app>
    <div class="pqrs-commercial-container">
      <div class="hero-section">
        <v-container fluid class="py-8">
          <v-row justify="center" align="center">
            <v-col cols="12" class="text-center">
              <div class="logo-container mb-4">
                <v-img class="shadow-img mx-auto" max-width="200" src="@/assets/images/logoCohanMasVital.png"></v-img>
              </div>

              <h1 class="hero-title text-h3 font-weight-bold mb-3">
                <span class="primary--text">PQRS</span>
                <span class="dark--text">Comercial</span>
              </h1>

              <p class="hero-subtitle subtitle-1 grey--text text--darken-1 mb-2">
                Sistema de Peticiones, Quejas, Reclamos y Sugerencias
              </p>

              <p class="hero-description body-1 grey--text text--darken-2">
                Gestiona tus solicitudes de manera fácil y rápida.
                Crea una nueva PQRS o consulta el estado de tu solicitud existente.
              </p>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <v-container class="main-actions py-8">
        <v-row justify="center" class="mx-auto" style="max-width: 1200px">

          <v-col cols="12" md="6" class="pa-4">
            <v-card class="action-card create-card h-100" elevation="8" hover @click="navigateToCreate">
              <div class="card-gradient create-gradient"></div>
              <v-card-text class="pa-8 d-flex flex-column justify-center align-center text-center position-relative">
                <div class="action-icon-container mb-6">
                  <v-icon size="80" class="action-icon create-icon">edit</v-icon>
                </div>

                <h2 class="action-title text-h4 font-weight-medium mb-4">
                  Crear nueva PQRS
                </h2>

                <p class="action-description body-1 grey--text text--darken-1 mb-6">
                  Registra una nueva petición, queja, reclamo o sugerencia.
                  Nuestro equipo te ayudará a resolver tu solicitud.
                </p>

                <div class="action-features mb-6">
                  <div class="feature-item d-flex align-center mb-2">
                    <v-icon small class="mr-2 primary--text">check_circle</v-icon>
                    <span class="caption">Proceso rápido y sencillo</span>
                  </div>
                  <div class="feature-item d-flex align-center mb-2">
                    <v-icon small class="mr-2 primary--text">security</v-icon>
                    <span class="caption">Información segura y protegida</span>
                  </div>
                  <div class="feature-item d-flex align-center">
                    <v-icon small class="mr-2 primary--text">support_agent</v-icon>
                    <span class="caption">Seguimiento personalizado</span>
                  </div>
                </div>

                <v-btn large color="primary" elevation="4" class="action-button" @click.stop="navigateToCreate">
                  <v-icon left>add_circle</v-icon> Crear PQRS </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" class="pa-4">
            <v-card class="action-card search-card h-100" elevation="8" hover @click="navigateToSearch">
              <div class="card-gradient search-gradient"></div>
              <v-card-text class="pa-8 d-flex flex-column justify-center align-center text-center position-relative">
                <div class="action-icon-container mb-6">
                  <v-icon size="80" class="action-icon search-icon">search</v-icon>
                </div>

                <h2 class="action-title text-h4 font-weight-medium mb-4"> Consultar PQRS </h2>

                <p class="action-description body-1 grey--text text--darken-1 mb-6">
                  Busca el estado de tu solicitud utilizando
                  el número de ticket que recibiste. Podrás ver el progreso de tu caso
                  de manera fácil y rápida.
                </p>

                <div class="action-features mb-6">
                  <div class="feature-item d-flex align-center mb-2">
                    <v-icon small class="mr-2 success--text">visibility</v-icon>
                    <span class="caption">Estado en tiempo real</span>
                  </div>
                  <div class="feature-item d-flex align-center mb-2">
                    <v-icon small class="mr-2 success--text">timeline</v-icon>
                    <span class="caption">Historial completo</span>
                  </div>
                  <div class="feature-item d-flex align-center">
                    <v-icon small class="mr-2 success--text">notifications</v-icon>
                    <span class="caption">Actualizaciones automáticas</span>
                  </div>
                </div>

                <v-btn large color="success" elevation="4" class="action-button" @click.stop="navigateToSearch">
                  <v-icon left>search</v-icon> Buscar Ticket </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


    </div>
  </v-app>
</template>

<!-- #################################################################################### -->
<!-- ###### Sección de Scripts                                                     ###### -->
<!-- #################################################################################### -->
<script>
export default {
  name: 'PqrsComercial',

  data() {
    return {};
  },

  methods: {
    navigateToCreate() {
      window.location.href = `/#/external/form-comercial`;
      window.location.reload();
    },

    navigateToSearch() {
      window.location.href = `/#/external/search-pqrs`;
      window.location.reload();
    },

  }
};
</script>

<!-- #################################################################################### -->
<!-- ###### Sección de Estilos                                                     ###### -->
<!-- #################################################################################### -->
<style scoped>
.pqrs-commercial-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.hero-section {
  background: #ffffff;
  border-bottom: 1px solid #e0e4e7;
  position: relative;
  overflow: hidden;
}

.logo-container {
  position: relative;
  z-index: 2;
}

.shadow-img {
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
  transition: all 0.3s ease;
  border-radius: 8px;
}

.shadow-img:hover {
  transform: scale(1.03);
  filter: drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.15));
}

.hero-title {
  position: relative;
  z-index: 2;
  color: #2c3e50;
}

.hero-subtitle {
  position: relative;
  z-index: 2;
  color: #546e7a !important;
  font-weight: 500;
}

.hero-description {
  position: relative;
  z-index: 2;
  color: #607d8b !important;
  max-width: 600px;
  margin: 0 auto;
}

.main-actions {
  margin-top: -20px;
  position: relative;
  z-index: 3;
}

.action-card {
  min-height: 450px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 16px !important;
}

.action-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

.card-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  z-index: 1;
}

.create-gradient {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.search-gradient {
  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);
}

.action-icon-container {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  padding: 20px;
  display: inline-block;
}

.action-icon {
  transition: all 0.3s ease;
}

.create-icon {
  color: #667eea;
}

.search-icon {
  color: #4CAF50;
}

.action-card:hover .action-icon {
  transform: scale(1.1);
}

.action-title {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.action-description {
  line-height: 1.6;
  max-width: 280px;
  margin: 0 auto;
}

.action-features {
  max-width: 260px;
  margin: 0 auto;
}

.feature-item {
  justify-content: flex-start;
}

.action-button {
  border-radius: 25px !important;
  padding: 0 30px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.quick-search-section {
  background: white;
  border-top: 1px solid #e0e0e0;
}

.quick-search-card {
  border-radius: 12px !important;
}

.help-section {
  background: #fafafa;
}

.help-card {
  border-radius: 12px !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .main-actions {
    margin-top: -15px;
  }

  .action-card {
    min-height: 400px;
    margin-bottom: 20px;
  }

  .hero-title {
    font-size: 2rem !important;
  }

  .action-title {
    font-size: 1.5rem !important;
  }
}

@media (max-width: 600px) {
  .pqrs-commercial-container {
    padding: 0;
  }

  .main-actions {
    margin-top: -10px;
  }

  .action-card {
    min-height: 350px;
  }

  .action-icon-container {
    padding: 15px;
  }

  .action-icon {
    font-size: 60px !important;
  }

  .hero-title {
    font-size: 1.75rem !important;
  }

  .action-title {
    font-size: 1.25rem !important;
  }

  .hero-description {
    font-size: 0.9rem !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.action-card:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.action-button:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
}
</style>
